import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import { Button } from "@components/Button";
import { Waitlist } from "../Waitlist";
import { nodeToId } from "../lib/product-utils";
import styles from "./styles/view.module.css";

export function ProductFormFooter({
  productTitle,
  variant,
  loading,
  addToCart,
  comingSoon,
  waitlistMessage,
}) {
  const { t } = useTranslation("productpage");

  const displayButton = () => {
    if (!variant.availableForSale) {
      return (
        <Waitlist
          variantID={variant.id}
          variantTitle={variant.title}
          productTitle={productTitle}
          isComingSoon={comingSoon}
          waitlistMessage={waitlistMessage}
        />
      );
    }
    return (
      <Button
        handleClick={addToCart}
        isDisabled={loading}
        description="addToBag"
        descriptionText="Click to add to bag"
      >
        {loading ? t("adding") : t("add-to-bag-button")}
      </Button>
    );
  };
  return (
    <div className={styles.formFooter} data-cy="addToBag">
      <div className={styles.buttonContainer}>{displayButton()}</div>
    </div>
  );
}

ProductFormFooter.propTypes = {
  productTitle: PropTypes.string.isRequired,
  variant: PropTypes.shape({
    availableForSale: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    priceV2:  PropTypes.shape({
          amount: PropTypes.string,
          currencyCode: PropTypes.string,
    }),
    compareAtPriceV2:  PropTypes.shape({
      amount: PropTypes.string,
      currencyCode: PropTypes.string,
  }),
    // presentmentPrices: PropTypes.arrayOf(
    //   PropTypes.shape({
    //     compareAtPrice: PropTypes.shape({
    //       amount: PropTypes.string,
    //       currencyCode: PropTypes.string,
    //     }),
    //     price: PropTypes.shape({
    //       amount: PropTypes.string,
    //       currencyCode: PropTypes.string,
    //     }),
    //   })
    // ),
    quantityAvailable: PropTypes.number.isRequired,
    selectedOptions: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      })
    ),
    sku: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  addToCart: PropTypes.func.isRequired,
};
